import { useQueryClient } from 'react-query';
import moment from 'moment';
import { useCallback } from 'react';
import { CacheKeys } from '../constants';
export const useLocalConversationCreation = () => {
    const queryClient = useQueryClient();
    const mutate = useCallback((data) => {
        const conversations = queryClient.getQueryData([CacheKeys.CONVERSATIONS, data.status]);
        if (conversations &&
            !conversations.pages
                .flatMap(({ records }) => records)
                .find(({ id }) => id === data.id)) {
            queryClient.setQueryData([CacheKeys.CONVERSATIONS, data.status], Object.assign(Object.assign({}, conversations), { pages: conversations.pages.map((page, index) => (Object.assign(Object.assign({}, page), { records: index !== 0
                        ? page.records
                        : [data, ...page.records].sort((a, b) => moment(b.updatedAt).valueOf() -
                            moment(a.updatedAt).valueOf()) }))) }));
        }
    }, []);
    return { mutate };
};
//# sourceMappingURL=useLocalConversationCreation.js.map